export const shuffleArray = (arr: any[]) => 
    [...arr].sort(() => Math.random() - 0.5);
